// extracted by mini-css-extract-plugin
export default {"switch":"toggle_switch__zgDO1","slider":"toggle_slider__mz5gh","input":"toggle_input__R6JPF","round":"toggle_round__pRAwl"};